module.exports = __webpack_public_path__ + "static/media/image_rec.a65f5a10.png";